module.exports = __webpack_public_path__ + "media/images/photo/features/reliable_speed-51d36e015bd62bf1b68b1f9ae48bd943.svg";